<!--
 * @Author: GeekMzy
 * @Date: 2023-02-15 14:52:04
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\Dialog\StationPhotoDialog.vue
-->
<template>
  <n-modal v-model:show="dialogVisible" class="my-dialog">
    <n-card style="width: auto" :bordered="false" size="huge" role="dialog" aria-modal="true">
      <n-image-group>
        <n-space>
          <n-image lazy width="400" v-for="(img, index) in imgArr" :src="img" :key="index" />
        </n-space>
      </n-image-group>
    </n-card>
  </n-modal>
</template>

<script setup>
import { nextTick, markRaw } from 'vue'
import { ref } from 'vue-demi'

const imgArr = ["https://xcx.ljh.cqhtwl.com.cn/files/permanent-bucket/temp/live/wandang1.jpg", "https://xcx.ljh.cqhtwl.com.cn/files/permanent-bucket/temp/live/wandang2.jpg", "https://xcx.ljh.cqhtwl.com.cn/files/permanent-bucket/temp/live/wandang3.jpg", "https://xcx.ljh.cqhtwl.com.cn/files/permanent-bucket/temp/live/wandang4.jpg"]
const dialogVisible = ref(false)
const open = () => {
  dialogVisible.value = true
}
const close = () => {
  dialogVisible.value = false
}
const afterLeave = () => {
  changeTab('')
  modal = ''
  data.value = {}
  Bus.emit('onClose')
}
defineExpose({
  close,
  open,
})
</script>

<style lang="scss" scoped>
.img_dialog {
  width: 600px;
  height: 500px;
}
</style>
